module.exports = __webpack_public_path__ + "img/new-credit.57bc18f8.jpg";